<!--
 * @Author: xionggang
 * @Date: 2021-08-02 10:08:52
 * @LastEditTime: 2021-08-25 17:38:31
 * @Descripttion: 
 * @version: 
 * @LastEditors: xionggang
-->
<template>
  <div>
    <div class="text">{{ videoInfo.name }}</div>
    <div class="tag">
      <!-- <div v-if="swiperIndex!=2">
        <span>兑换"京医育儿说"解锁更多育儿知识</span> 
      </div>
      <div v-else>  
      <span>钻石{{pointTip(videoInfo.diamondIntegral)}}</span>
      <span>铂金{{ pointTip(videoInfo.platinumIntegral) }}</span>
      <span>黄金{{ pointTip(videoInfo.goidIntegral) }}</span>
      </div> -->
      <div>
        <span>
          点击下方解锁更多精彩内容
          <img src="@/assets/images/bjDoctor/next_three.svg" alt="" />
          <div></div>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    videoInfo: {
      type: Object
    },
    swiperIndex: {
      type: Number
    }
  },
  computed: {
    pointTip() {
      return (integral) => {
        return integral > 0 ? integral + "积分" : "免费"
      }
    }
  }
}
</script>
<style lang="less" scoped>
.text {
  font-size: 16px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 22px;
  margin: 12px 12px 0 12px;
}
.tag {
  // margin: 0 0 10px 0;
  span {
    display: flex;
    justify-content: space-around;
    align-items: center;
    display: inline-flex;
    // min-width: 61px;
    width: auto;
    padding: 0 10px;
    height: 18px;
    background: linear-gradient(270deg, #d4a437 0%, #e5bf5d 100%);
    border-radius: 9px;
    color: #ffffff;
    font-size: 12px;
    justify-content: center;
    align-items: center;
    margin: 5px 5px 0 12px;
    img {
      margin-left: 2px;
      width: 12px;
      height: 12px;
    }
  }
}
</style>
